<template lang="pug">
modal#rename-folder-modal(
  :noFooter='true'
  :title='$t("modal.renameFolder.title")'
  @closed='close'
  ref='modal'
)
  ValidationObserver(ref='form' v-slot='{ valid, passes, handleSubmit }')
    form.form(@submit.prevent='handleSubmit(renameFolder)')
      .row
        .col-12.mb-3
          label(for='folder-name') {{ $t('modal.renameFolder.folderNameLabel') }}
          .form-control-icon
            icon(name='folder')
            ValidationProvider(
              name='name'
              rules='required'
              v-slot='{ errors }'
            )
              input#folder-name.form-control.rounded-1(
                :class='{ "border border-danger": errors[0] }'
                :placeholder='$t("modal.renameFolder.folderNamePlaceholder")'
                autocomplete='off'
                type='text'
                v-model='form.editableFolderName'
              )
              small.text.text-danger.d-flex(v-if='errors.length > 0')
                icon(name='xmark')
                span.text.ms-2 {{ errors[0] }}
      .text-end.mt-2
        button.btn.btn-secondary(@click='close' type='button') {{ $t('button.cancel') }}
        button.btn.btn-primary.ms-2(:disabled='!valid' type='submit')
          | {{ $t('button.save') }}
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';
import StorageHttp from '@/services/StorageHttp';
import alert from '@/modules/account/common/alert';

export default {
  components: {
    Modal,
    Icon,
  },
  props: {
    folder: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        editableFolderName: this.folder.name,
      },
      errors: [],
    };
  },
  watch: {
    folder(newValue) {
      this.form.editableFolderName = newValue.name;
    },
  },
  methods: {
    renameFolder() {
      this.$loading(true);
      StorageHttp.supressDefault = true;
      StorageHttp.renameItem(this.folder.id, this.form.editableFolderName)
        .then(() => {
          this.$emit('renamed');
          this.$refs.modal.close();
        })
        .catch((err) => {
          if (err.response.status === 422) {
            this.$refs.form.setErrors(err.response.data.errors);
          }

          if (err.response.status === 404) {
            this.$refs.modal.close();
            alert.fireAlert(this.$t('alert.folderNotFoundError'), {
              classes: 'alert-danger',
              styles:
                'background-color: #f8d7da; border-color: #f5c6cb; color: #721c24;',
              icon: 'triangle-exclamation',
            });
          }
        })
        .finally(() => {
          this.$loading(false);
          StorageHttp.supressDefault = false;
        });
    },
    resetForm() {
      this.form.editableFolderName = this.folder.name;
      this.$refs.form.reset();
    },
    close() {
      this.resetForm();
      this.$refs.modal.close();
    },
  },
};
</script>

<style scoped lang="stylus">
#folder-name
  padding: 0px 45px
</style>
